// extracted by mini-css-extract-plugin
export var ellipsesOverflow = "_es-a";
export var fulfillmentFormRail = "_es-9";
export var headerTitleRow = "_es-c";
export var orderDetailsWrapper = "_es-7";
export var orderLinkTrigger = "_es-2";
export var paymentInformationGrid = "_es-h";
export var paymentSummaryColumn = "_es-i";
export var shipmentContainer = "_es-b";
export var shipmentDetailsMainPane = "_es-8";
export var shipmentNavigationCard = "_es-5";
export var shipmentNavigationRail = "_es-3";
export var shipmentNavigationRailHeader = "_es-4";
export var shipmentSummaryFact = "_es-e";
export var shipmentSummaryGrid = "_es-d";
export var shipmentSummaryMetadataRow = "_es-f";
export var shipmentSummaryTags = "_es-g";
export var shipmentWorkspace = "_es-0";
export var shipmentWorkspaceContent = "_es-6";
export var shipmentWorkspaceHeader = "_es-1";